(function () {

  'use strict';

  function pxRequireIdpLoginToken($rootScope) {
    return {
      restrict: 'EA',
      scope: {},
      templateUrl: 'app/components/authenticationSettings/requireIdpLoginToken/requireIdpLoginToken.template.html',
      link: function (scope) {
        scope.confirm = { signOut: false };
        scope.signOut = function () {
          $rootScope.signOut();
        };
      }
    };
  }

  pxRequireIdpLoginToken.$inject = ['$rootScope'];

  angular
    .module('printix-admin')
    .directive('pxRequireIdpLoginToken', pxRequireIdpLoginToken);

})();
